import React, { useState } from 'react'
import { Box, Button, Typography } from '@mui/material'

import { SvgIcon } from '#/shared/ui/svg'
import { TourName } from '../lib/constants'
import { TourModal } from './tour-modal'
import { TourConfirmSkipModal } from './tour-confirm-skip-modal'

import styles from './tour-selector.module.scss'

interface TourSelectorProps {
	open: boolean
	onSelect: (tourName: TourName) => void
	onSkip?: () => void
}

export const TourSelector: React.FC<TourSelectorProps> = ({ open, onSelect, onSkip }) => {
	const [confirmSkipModal, setConfirmSkipModal] = useState(false)

	const handleClose = () => {
		setConfirmSkipModal(true)
	}

	const handleConfirmSkip = () => {
		setConfirmSkipModal(false)
		if (onSkip) {
			onSkip()
		}
	}

	return (
		<>
			<TourModal open={open && !confirmSkipModal} onClose={handleClose}>
				<Box className={styles.container}>
					<Typography variant="h5" className={styles.title}>
						Что вы хотели сгенерировать?
					</Typography>
					<Box className={styles.buttonsContainer}>
						<Button
							variant="outlined"
							fullWidth
							size="large"
							onClick={() => onSelect('text-models')}
							className={`${styles.button} ${styles.buttonText}`}
						>
							<Box className={styles.buttonContent}>
								<Box className={styles.icon}>
									<SvgIcon url="/svg/tour/text-align-left-svgrepo-com.svg" width={48} height={48} color="white" />
								</Box>
								<Typography className={styles.buttonLabel}>Хочу генерировать тексты</Typography>
							</Box>
						</Button>
						<Button
							variant="outlined"
							fullWidth
							size="large"
							onClick={() => onSelect('images')}
							className={`${styles.button} ${styles.buttonText}`}
						>
							<Box className={styles.buttonContent}>
								<Box className={styles.icon}>
									<SvgIcon url="/svg/tour/picture-svgrepo-com.svg" width={48} height={48} color="white" />
								</Box>
								<Typography className={styles.buttonLabel}>Хочу генерировать изображения</Typography>
							</Box>
						</Button>
					</Box>
					<Typography className={styles.skipLink} onClick={handleClose}>
						Пропустить обучение &gt;
					</Typography>
				</Box>
			</TourModal>
			<TourConfirmSkipModal
				open={confirmSkipModal}
				onConfirm={handleConfirmSkip}
				onClose={() => setConfirmSkipModal(false)}
			/>
		</>
	)
}

